import { setAuthenticatedUserContext } from "@/datadog-rum";
import { ConfirmDialog } from "@/shared/components/common/confirm-dialog";
import { ConfirmPopover } from "@/shared/components/common/confirm-popover";
import { GlobalSheet } from "@/shared/components/global-sheet";
import SmallScreenMessage from "@/shared/components/small-screen-message";
import { useScreenSize } from "@/shared/hooks/use-screen-size";
import { useGetMe } from "@/spz-api/user/user";
import Loader from "@spz/ui/components/loader";
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router";
import { AppSidebar } from "../app-sidebar";
import { GlobalDialog } from "../common/global-dialog";

export const AuthenticatedLayout: React.FC = () => {
  const { isTooSmall } = useScreenSize();

  const { data: me } = useGetMe();

  if (isTooSmall) {
    return <SmallScreenMessage />;
  }

  if (me) {
    // Set Datadog RUM context for better tracking
    setAuthenticatedUserContext(me);

    const isOnboardingRoute = location.pathname === "/onboarding";

    // Redirect to onboarding if not completed and not on onboarding page
    if (!me.onboardingCompletedAt && !isOnboardingRoute) {
      return <Navigate to="/onboarding" replace />;
    }
  }

  return (
    <div className="flex h-screen">
      <AppSidebar />
      <div className="flex-1 overflow-auto px-6 pt-6 pb-9">
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>

        <GlobalSheet />
        <ConfirmDialog />
        <GlobalDialog />
        <ConfirmPopover />
      </div>
    </div>
  );
};
